import { IShip } from '../../../data/types/ship/ship';
import { getShipConfig } from '../../../config/ship/get-ship-config';

export const getPossibleHullToRepair = (ship: IShip, credits: number): number =>
  Math.floor(credits / getShipConfig(ship).repairCosts);
